// extracted by mini-css-extract-plugin
module.exports = {"tagStyle":"delivery-tag_tagStyle__3TrcD","dotStyle":"delivery-tag_dotStyle__jGKx5"};